// 見積書マスタ 新規作成・編集画面
import React, { useState, useCallback, useEffect, useMemo } from 'react';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import {
  useMediaQuery,
  Button,
  Divider,
  Table,
  TableBody,
  TableContainer,
  Paper,
  Snackbar,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid
} from '@material-ui/core';
import NumberInput from '../components/NumberInput';
import NumberInputCostUnitPrice from '../components/NumberInputCostUnitPrice';
import { useHistory, Redirect, useParams, useLocation } from 'react-router-dom';
import './List.css';
import { useRecoilState } from 'recoil';
import { isLoggedIn, btnColor } from '../GlobalState';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import {
  createEstimateMaster,
  getEstimateMasterListDetails,
  updateEstimateMaster,
  deleteEstimateMasterList
} from '../apicalls/esimateMaster';
import { getUnitMasterList } from '../apicalls/unitMaster';
import _ from 'lodash';
import LoadingComponent from '../components/LoadingComponent';
import { parsePrice } from '../utils';
import { validateTextareaInput } from '../utils/estimate';
import { v4 as uuidv4 } from 'uuid';
import { useStyles } from '../components/editEstimateMaster/Style';
import { AddUnderLayerItemButtom } from '../components/editEstimateMaster/AddUnderLayerButton';
import { ItemList } from '../components/editEstimateMaster/ItemList';
import { Breadcrumbs } from '../components/editEstimateMaster/Breadcrumbs';
import { ItemTableHead } from '../components/editEstimateMaster/TableHead';
import { reduceArr } from '../utils/estimate';
import { handleTextValidation } from '../../src/utils/estimate';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import { ESTIMATE_ITEM_MAX } from '../const/Const';
import {
  TEMasterBaseItem,
  TMainItem,
  TSecondItem,
  TNewSecondItem,
  TNewThirdItem,
  TNewFourthItem,
  TNewFifthItem
} from '../types/estimate/estimateMaster';
import { progressFlgState } from '../GlobalState';
import { DocumentDeleteModal } from '../components/DocumentDeleteModal';
import {
  calcAllCostPrice,
  calcAllSellingPrice,
  calcGrossProfit,
  calcGrossProfitMargin
} from '../utils/calcRules';

export const EditEstimateMaster: React.FC = () => {
  const baseSecondItem = useMemo(
    () => ({
      name: '',
      spec: '',
      order_id: 0,
      quantity: '',
      costQuantity: '',
      unitId: 0,
      costUnitId: 0,
      sellingUnitPrice: 0,
      costUnitPrice: 0,
      allSellingPrice: 0,
      allCostPrice: 0,
      grossProfit: 0,
      grossProfitMargin: 0,
      remarks: '',
      author_memo: '',
      hasUnderLayerFlg: false,
      childItems: []
    }),
    []
  );

  const baseMainItem = useMemo(
    () => ({
      name: '',
      spec: '',
      order_id: 0,
      quantity: 1,
      costQuantity: 1,
      unitId: 0,
      costUnitId: 0,
      sellingUnitPrice: 0,
      costUnitPrice: 0,
      allSellingPrice: 0,
      allCostPrice: 0,
      grossProfit: 0,
      grossProfitMargin: 0,
      remarks: '',
      author_memo: '',
      layer: 1,
      hasUnderLayerFlg: true
    }),
    []
  );

  const matches2 = useMediaQuery('(min-width:900px)');
  const [buttonColor] = useRecoilState(btnColor);

  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);
  // 帳票削除アラート
  const [documentDeleteModal, setDocumentDeleteModal] =
    useState<boolean>(false);

  const history: any = useHistory();
  const params: any = useParams();
  const classes = useStyles();
  const location: any = useLocation();

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const [mUnitsData, setMUnitsData] = useState([]);
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );
  const [loading, setLoading] = useState(true);

  const [secondItems, setSecondItems] = useState<TSecondItem[]>([]);
  const [mainItem, setMainItem] = useState<TMainItem>(baseMainItem);

  /**
   * 単位マスタの取得
   */
  const getListOfMUnits = useCallback(() => {
    getUnitMasterList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setMUnitsData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  /**
   * 詳細の取得
   */
  const getTheListOfEstimateMasterDetails = useCallback(() => {
    if (loading === true) {
      getEstimateMasterListDetails(params.id).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              const mainSellingArr: number[] = [];
              const mainCostArr: number[] = [];

              // 第二階層以下
              const tempSecondItems: TSecondItem[] = [];
              if (
                data.data.has_under_layer_flg &&
                data.data.second_items.length > 0
              ) {
                // 階層別に振り分け
                const allSecondItems = data.data.second_items.filter(
                  (item: TEMasterBaseItem) => {
                    return item.layer === 2;
                  }
                );
                const allThirdItems = data.data.second_items.filter(
                  (item: TEMasterBaseItem) => {
                    return item.layer === 3;
                  }
                );
                const allFourthItems = data.data.second_items.filter(
                  (item: TEMasterBaseItem) => {
                    return item.layer === 4;
                  }
                );
                const allFifthItems = data.data.second_items.filter(
                  (item: TEMasterBaseItem) => {
                    return item.layer === 5;
                  }
                );

                allSecondItems.forEach((second_item: TEMasterBaseItem) => {
                  const secondSellingArr: number[] = [];
                  const secondCostArr: number[] = [];
                  const tempThirdItems: TSecondItem[] = [];

                  if (second_item.has_under_layer_flg) {
                    // ２階層が明細ありの場合、idが位置する３階層を取得
                    const thirdItems = allThirdItems.filter(
                      (allThirdItem: TEMasterBaseItem) => {
                        return allThirdItem.parent_item_id === second_item.id;
                      }
                    );
                    if (thirdItems.length > 0) {
                      thirdItems.forEach((third_item: TEMasterBaseItem) => {
                        const thirdSellingArr: number[] = [];
                        const thirdCostArr: number[] = [];
                        const tempFourthItems: TSecondItem[] = [];

                        if (third_item.has_under_layer_flg) {
                          // ３階層が明細ありの場合、idが位置する４階層を取得
                          const fourthItems = allFourthItems.filter(
                            (allFourthItem: TEMasterBaseItem) => {
                              return (
                                allFourthItem.parent_item_id === third_item.id
                              );
                            }
                          );
                          if (fourthItems.length > 0) {
                            fourthItems.forEach(
                              (fourth_item: TEMasterBaseItem) => {
                                const fourthSellingArr: number[] = [];
                                const fourthCostArr: number[] = [];
                                const tempFifthItems: TEMasterBaseItem[] = [];
                                if (fourth_item.has_under_layer_flg) {
                                  //４階層が明細ありの場合、idが位置する５階層を取得
                                  const fifthItems = allFifthItems.filter(
                                    (allFifthItem: TEMasterBaseItem) => {
                                      return (
                                        allFifthItem.parent_item_id ===
                                        fourth_item.id
                                      );
                                    }
                                  );
                                  if (fifthItems.length > 0) {
                                    fifthItems.forEach(
                                      (fifth_item: TEMasterBaseItem) => {
                                        let fifthObj: any = {};
                                        fifthObj.name = fifth_item.name;
                                        fifthObj.spec = fifth_item.spec;
                                        fifthObj.quantity = fifth_item.quantity;
                                        fifthObj.costQuantity =
                                          fifth_item.cost_quantity;
                                        fifthObj.unitId = fifth_item.unit_id;
                                        fifthObj.costUnitId =
                                          fifth_item.cost_unit_id;
                                        fifthObj.sellingUnitPrice =
                                          fifth_item.selling_unit_price;
                                        fifthObj.costUnitPrice =
                                          fifth_item.cost_unit_price;
                                        fifthObj.remarks = fifth_item.remarks;
                                        fifthObj.author_memo =
                                          fifth_item.author_memo;
                                        fifthObj.parentItemId =
                                          fifth_item.parent_item_id;
                                        fifthObj.layer = fifth_item.layer;
                                        fifthObj.hasUnderLayerFlg =
                                          fifth_item.has_under_layer_flg;
                                        fifthObj.allSellingPrice =
                                          calcAllSellingPrice(
                                            fifth_item.quantity,
                                            fifth_item.selling_unit_price
                                          );
                                        fifthObj.allCostPrice =
                                          calcAllCostPrice(
                                            fifth_item.cost_quantity,
                                            fifth_item.cost_unit_price
                                          );
                                        fifthObj.grossProfit = calcGrossProfit(
                                          fifthObj.allSellingPrice,
                                          fifthObj.allCostPrice
                                        );
                                        fifthObj.grossProfitMargin =
                                          calcGrossProfitMargin(
                                            fifthObj.allSellingPrice,
                                            fifthObj.allCostPrice
                                          );
                                        fourthSellingArr.push(
                                          fifthObj.allSellingPrice
                                        );
                                        fourthCostArr.push(
                                          fifthObj.allCostPrice
                                        );
                                        tempFifthItems.push(fifthObj);
                                      }
                                    );
                                  }
                                }
                                let fourthObj: any = {};
                                fourthObj.name = fourth_item.name;
                                fourthObj.spec = fourth_item.spec;
                                fourthObj.quantity = fourth_item.quantity;
                                fourthObj.costQuantity =
                                  fourth_item.cost_quantity;
                                fourthObj.unitId = fourth_item.unit_id;
                                fourthObj.costUnitId = fourth_item.cost_unit_id;
                                fourthObj.sellingUnitPrice =
                                  fourth_item.selling_unit_price;
                                fourthObj.costUnitPrice =
                                  fourth_item.cost_unit_price;
                                fourthObj.remarks = fourth_item.remarks;
                                fourthObj.author_memo = fourth_item.author_memo;
                                fourthObj.parentItemId =
                                  fourth_item.parent_item_id;
                                fourthObj.layer = fourth_item.layer;
                                fourthObj.hasUnderLayerFlg =
                                  fourth_item.has_under_layer_flg;
                                fourthObj.childItems = tempFifthItems;

                                if (fourthSellingArr.length > 0) {
                                  fourthObj.sellingUnitPrice =
                                    reduceArr(fourthSellingArr);
                                  fourthObj.costUnitPrice =
                                    reduceArr(fourthCostArr);
                                }

                                fourthObj.allSellingPrice = calcAllSellingPrice(
                                  fourth_item.quantity,
                                  fourthObj.sellingUnitPrice
                                );
                                fourthObj.allCostPrice = calcAllCostPrice(
                                  fourth_item.cost_quantity,
                                  fourthObj.costUnitPrice
                                );

                                fourthObj.grossProfit = calcGrossProfit(
                                  fourthObj.allSellingPrice,
                                  fourthObj.allCostPrice
                                );
                                fourthObj.grossProfitMargin =
                                  calcGrossProfitMargin(
                                    fourthObj.allSellingPrice,
                                    fourthObj.allCostPrice
                                  );
                                thirdSellingArr.push(fourthObj.allSellingPrice);
                                thirdCostArr.push(fourthObj.allCostPrice);
                                tempFourthItems.push(fourthObj);
                              }
                            );
                          }
                        }
                        let thirdObj: any = {};
                        thirdObj.name = third_item.name;
                        thirdObj.spec = third_item.spec;
                        thirdObj.quantity = third_item.quantity;
                        thirdObj.costQuantity = third_item.cost_quantity;
                        thirdObj.unitId = third_item.unit_id;
                        thirdObj.costUnitId = third_item.cost_unit_id;
                        thirdObj.sellingUnitPrice =
                          third_item.selling_unit_price;
                        thirdObj.costUnitPrice = third_item.cost_unit_price;
                        thirdObj.remarks = third_item.remarks;
                        thirdObj.author_memo = third_item.author_memo;
                        thirdObj.parentItemId = third_item.parent_item_id;
                        thirdObj.layer = third_item.layer;
                        thirdObj.hasUnderLayerFlg =
                          third_item.has_under_layer_flg;
                        thirdObj.childItems = tempFourthItems;
                        if (thirdSellingArr.length > 0) {
                          thirdObj.sellingUnitPrice =
                            reduceArr(thirdSellingArr);
                          thirdObj.costUnitPrice = reduceArr(thirdCostArr);
                        }

                        thirdObj.allSellingPrice = calcAllSellingPrice(
                          third_item.quantity,
                          thirdObj.sellingUnitPrice
                        );
                        thirdObj.allCostPrice = calcAllCostPrice(
                          third_item.cost_quantity,
                          thirdObj.costUnitPrice
                        );

                        thirdObj.grossProfit = calcGrossProfit(
                          thirdObj.allSellingPrice,
                          thirdObj.allCostPrice
                        );
                        thirdObj.grossProfitMargin = calcGrossProfitMargin(
                          thirdObj.allSellingPrice,
                          thirdObj.allCostPrice
                        );
                        secondSellingArr.push(thirdObj.allSellingPrice);
                        secondCostArr.push(thirdObj.allCostPrice);
                        tempThirdItems.push(thirdObj);
                      });
                    }
                  }
                  let secondObj: any = {};
                  secondObj.name = second_item.name;
                  secondObj.spec = second_item.spec;
                  secondObj.quantity = second_item.quantity;
                  secondObj.costQuantity = second_item.cost_quantity;
                  secondObj.unitId = second_item.unit_id;
                  secondObj.costUnitId = second_item.cost_unit_id;
                  secondObj.sellingUnitPrice = second_item.selling_unit_price;
                  secondObj.costUnitPrice = second_item.cost_unit_price;
                  secondObj.remarks = second_item.remarks;
                  secondObj.author_memo = second_item.author_memo;
                  secondObj.parentItemId = second_item.parent_item_id;
                  secondObj.layer = second_item.layer;
                  secondObj.hasUnderLayerFlg = second_item.has_under_layer_flg;
                  secondObj.childItems = tempThirdItems;
                  if (secondSellingArr.length > 0) {
                    secondObj.sellingUnitPrice = reduceArr(secondSellingArr);
                    secondObj.costUnitPrice = reduceArr(secondCostArr);
                  }

                  secondObj.allSellingPrice = calcAllSellingPrice(
                    second_item.quantity,
                    secondObj.sellingUnitPrice
                  );
                  secondObj.allCostPrice = calcAllCostPrice(
                    second_item.cost_quantity,
                    secondObj.costUnitPrice
                  );

                  secondObj.grossProfit = calcGrossProfit(
                    secondObj.allSellingPrice,
                    secondObj.allCostPrice
                  );
                  secondObj.grossProfitMargin = calcGrossProfitMargin(
                    secondObj.allSellingPrice,
                    secondObj.allCostPrice
                  );
                  mainSellingArr.push(secondObj.allSellingPrice);
                  mainCostArr.push(secondObj.allCostPrice);
                  tempSecondItems.push(secondObj);
                });
              }
              // 第一階層
              let allSellingPrice = 0;
              let allCostPrice = 0;
              let sellingUnitPrice = 0;
              let costUnitPrice = 0;

              if (mainSellingArr.length > 0) {
                sellingUnitPrice = reduceArr(mainSellingArr);
                costUnitPrice = reduceArr(mainCostArr);
              } else {
                sellingUnitPrice = data.data.selling_unit_price;
                costUnitPrice = data.data.cost_unit_price;
              }
              allSellingPrice = calcGrossProfit(
                data.data.quantity,
                sellingUnitPrice
              );
              allCostPrice = calcGrossProfitMargin(
                data.data.cost_quantity,
                costUnitPrice
              );
              const MainGrossProfit = calcGrossProfit(
                allSellingPrice,
                allCostPrice
              );

              const tempMainItem: TMainItem = {
                name: data.data.name,
                spec: data.data.spec,
                order_id: data.data.order_id,
                quantity: data.data.quantity,
                costQuantity: data.data.cost_quantity,
                unitId: data.data.unit_id,
                costUnitId: data.data.cost_unit_id,
                sellingUnitPrice: sellingUnitPrice,
                costUnitPrice: costUnitPrice,
                remarks: data.data.remarks,
                author_memo: data.data.author_memo,
                layer: data.data.layer,
                hasUnderLayerFlg: data.data.has_under_layer_flg,
                allSellingPrice: allSellingPrice,
                allCostPrice: allCostPrice,
                grossProfit: MainGrossProfit,
                grossProfitMargin: calcGrossProfitMargin(
                  allSellingPrice,
                  allCostPrice
                )
              };
              setMainItem(tempMainItem);
              setSecondItems(tempSecondItems);
              setLoading(false);
            }
          }
        }
      });
    }
  }, [changeLoggedInData, loading, params.id]);

  /**
   * 初期値の設定
   */
  const initializeSecondItems = useCallback(() => {
    setMainItem(baseMainItem);
    setSecondItems([baseSecondItem]);
  }, [baseSecondItem]);

  /**
   * 項目の追加
   */
  const addNewItem = (
    layer: number,
    index?: any,
    thirdIndex?: any,
    fourthIndex?: any
  ) => {
    let copySecondItems = _.cloneDeep(secondItems);
    let newItem: any = baseSecondItem;
    newItem.id = uuidv4();

    switch (layer) {
      case 2:
        newItem.layer = 2;
        copySecondItems.push(newItem);
        break;
      case 3:
        newItem.layer = 3;
        copySecondItems[index].childItems.push(newItem);
        break;
      case 4:
        newItem.layer = 4;
        copySecondItems[index].childItems[thirdIndex].childItems.push(newItem);
        break;
      case 5:
        newItem.layer = 5;
        copySecondItems[index].childItems[thirdIndex].childItems[
          fourthIndex
        ].childItems.push(newItem);
        break;
      default:
        console.log('layer not found.');
        break;
    }
    setSecondItems([...copySecondItems]);
  };

  /**
   * 第一階層の更新
   */
  const updateMainItemList = (key: string, value: any) => {
    let copyMainItem = _.cloneDeep(mainItem);
    let calculationFlg = true; //再計算の有無

    copyMainItem[key] = value;

    // 明細選択の変更(再計算無し)
    if (key === 'hasUnderLayerFlg') {
      copyMainItem.hasUnderLayerFlg = mainItem.hasUnderLayerFlg ? false : true;
      calculationFlg = false;
    }

    // 単位の変更(再計算無し)
    if (key === 'unitId') {
      if (
        mainItem.quantity == mainItem.costQuantity &&
        mainItem.unitId == mainItem.costUnitId
      ) {
        copyMainItem.costUnitId = value;
      }
      calculationFlg = false;
    }

    // 名称・仕様・備考・原価単位の変更(再計算無し)
    if (
      key === 'name' ||
      key === 'spec' ||
      key === 'remarks' ||
      key === 'author_memo' ||
      key == 'costUnitId'
    ) {
      calculationFlg = false;
    }

    // 数量・原価数量
    if (key === 'quantity' || key == 'costQuantity') {
      //「単価・数量が原価単価・原価数量と同じ」場合、原価数量も同時に変更する
      if (
        mainItem.quantity == mainItem.costQuantity &&
        mainItem.unitId == mainItem.costUnitId
      ) {
        copyMainItem.costQuantity = value;
      }
    }

    if (key === 'sellingUnitPrice') {
      copyMainItem.sellingUnitPrice = value;
    }

    if (key === 'costUnitPrice') {
      copyMainItem.costUnitPrice = value;
    }

    if (calculationFlg) {
      copyMainItem.allSellingPrice = calcAllSellingPrice(
        copyMainItem.quantity,
        copyMainItem.sellingUnitPrice
      );
      copyMainItem.allCostPrice = calcAllCostPrice(
        copyMainItem.costQuantity,
        copyMainItem.costUnitPrice
      );
      copyMainItem.grossProfit = calcGrossProfit(
        copyMainItem.allSellingPrice,
        copyMainItem.allCostPrice
      );
      copyMainItem.grossProfitMargin = calcGrossProfitMargin(
        copyMainItem.allSellingPrice,
        copyMainItem.allCostPrice
      );
    }

    setMainItem(copyMainItem);
  };

  /**
   * 明細の更新
   * @param updated true->入力欄の更新  false->項目の削除
   */
  const updateSecondItemList = (
    updated: boolean,
    layer: number,
    key: string,
    value: any,
    index: number,
    thirdIndex?: any,
    fourthIndex?: any,
    fifthIndex?: any
  ) => {
    let copySecondItems = _.cloneDeep(secondItems);
    let calculationFlg = true; //再計算の有無

    if (updated) {
      switch (layer) {
        // 第二階層の入力
        case 2:
          copySecondItems[index][key] = value;

          // 明細選択の変更(再計算無し)
          if (key === 'hasUnderLayerFlg') {
            copySecondItems[index].hasUnderLayerFlg = secondItems[index]
              .hasUnderLayerFlg
              ? false
              : true;
            if (
              copySecondItems[index].hasUnderLayerFlg &&
              copySecondItems[index].quantity === ''
            ) {
              copySecondItems[index].quantity = 1;
              copySecondItems[index].costQuantity = 1;
            }
            calculationFlg = false;
            break;
          }

          // 単位の変更(再計算無し)
          if (key === 'unitId') {
            if (
              secondItems[index].quantity == secondItems[index].costQuantity &&
              secondItems[index].unitId == secondItems[index].costUnitId
            ) {
              copySecondItems[index].costUnitId = value;
            }
            calculationFlg = false;
            break;
          }

          // 名称・仕様・備考・原価単位の変更(再計算無し)
          if (
            key === 'name' ||
            key === 'spec' ||
            key === 'remarks' ||
            key === 'author_memo' ||
            key == 'costUnitId'
          ) {
            calculationFlg = false;
            break;
          }

          // 数量・原価数量
          if (key === 'quantity' || key === 'costQuantity') {
            //「単価・数量が原価単価・原価数量と同じ」場合、原価数量も同時に変更する
            if (
              secondItems[index].quantity == secondItems[index].costQuantity &&
              secondItems[index].unitId == secondItems[index].costUnitId
            ) {
              copySecondItems[index].costQuantity = value;
            }
          }

          // ２階層の粗利算出
          copySecondItems[index].allSellingPrice = calcAllSellingPrice(
            Number(copySecondItems[index].quantity),
            Number(copySecondItems[index].sellingUnitPrice)
          );
          copySecondItems[index].allCostPrice = calcAllCostPrice(
            Number(copySecondItems[index].costQuantity),
            Number(copySecondItems[index].costUnitPrice)
          );
          copySecondItems[index].grossProfit = calcGrossProfit(
            copySecondItems[index].allSellingPrice,
            copySecondItems[index].allCostPrice
          );
          copySecondItems[index].grossProfitMargin = calcGrossProfitMargin(
            copySecondItems[index].allSellingPrice,
            copySecondItems[index].allCostPrice
          );
          break;

        // 第三階層の入力
        case 3:
          copySecondItems[index].childItems[thirdIndex][key] = value;

          // 明細選択の変更(再計算無し)
          if (key === 'hasUnderLayerFlg') {
            copySecondItems[index].childItems[thirdIndex].hasUnderLayerFlg =
              secondItems[index].childItems[thirdIndex].hasUnderLayerFlg
                ? false
                : true;
            if (
              copySecondItems[index].childItems[thirdIndex].hasUnderLayerFlg &&
              copySecondItems[index].childItems[thirdIndex].quantity === ''
            ) {
              copySecondItems[index].childItems[thirdIndex].quantity = 1;
              copySecondItems[index].childItems[thirdIndex].costQuantity = 1;
            }
            calculationFlg = false;
            break;
          }

          //単位の変更(再計算無し)
          if (key === 'unitId') {
            if (
              secondItems[index].childItems[thirdIndex].quantity ==
                secondItems[index].childItems[thirdIndex].costQuantity &&
              secondItems[index].childItems[thirdIndex].unitId ==
                secondItems[index].childItems[thirdIndex].costUnitId
            ) {
              copySecondItems[index].childItems[thirdIndex].costUnitId = value;
            }
            calculationFlg = false;
            break;
          }

          // 名称・仕様・備考・原価単位の変更(再計算無し)
          if (
            key === 'name' ||
            key === 'spec' ||
            key === 'remarks' ||
            key === 'author_memo' ||
            key == 'costUnitId'
          ) {
            calculationFlg = false;
            break;
          }

          // 数量・原価数量
          if (key === 'quantity' || key === 'costQuantity') {
            //「単価・数量が原価単価・原価数量と同じ」場合、原価数量も同時に変更する
            if (
              secondItems[index].childItems[thirdIndex].quantity ==
                secondItems[index].childItems[thirdIndex].costQuantity &&
              secondItems[index].childItems[thirdIndex].unitId ==
                secondItems[index].childItems[thirdIndex].costUnitId
            ) {
              copySecondItems[index].childItems[thirdIndex].costQuantity =
                value;
            }
            let totalSellingPrice = 0;
            let totalCostPrice = 0;
            secondItems[index].childItems.forEach(thirdItem => {
              totalSellingPrice += thirdItem.allSellingPrice
                ? thirdItem.allSellingPrice
                : 0;
              totalCostPrice += thirdItem.allCostPrice
                ? thirdItem.allCostPrice
                : 0;
            });
            secondItems[index].childItems[thirdIndex].sellingUnitPrice =
              totalSellingPrice;
            secondItems[index].childItems[thirdIndex].costUnitPrice =
              totalCostPrice;
            secondItems[index].childItems[thirdIndex].allSellingPrice =
              totalSellingPrice * secondItems[index].quantity;
            secondItems[index].childItems[thirdIndex].allCostPrice =
              totalCostPrice * secondItems[index].costQuantity;
          }

          // ３階層の粗利算出
          copySecondItems[index].childItems[thirdIndex].allSellingPrice =
            calcAllSellingPrice(
              Number(copySecondItems[index].childItems[thirdIndex].quantity),
              Number(
                copySecondItems[index].childItems[thirdIndex].sellingUnitPrice
              )
            );
          copySecondItems[index].childItems[thirdIndex].allCostPrice =
            calcAllCostPrice(
              Number(
                copySecondItems[index].childItems[thirdIndex].costQuantity
              ),
              Number(
                copySecondItems[index].childItems[thirdIndex].costUnitPrice
              )
            );
          copySecondItems[index].childItems[thirdIndex].grossProfit =
            calcGrossProfit(
              copySecondItems[index].childItems[thirdIndex].allSellingPrice,
              copySecondItems[index].childItems[thirdIndex].allCostPrice
            );
          copySecondItems[index].childItems[thirdIndex].grossProfitMargin =
            calcGrossProfitMargin(
              copySecondItems[index].childItems[thirdIndex].allSellingPrice,
              copySecondItems[index].childItems[thirdIndex].allCostPrice
            );
          break;

        // 第四階層の入力
        case 4:
          copySecondItems[index].childItems[thirdIndex].childItems[fourthIndex][
            key
          ] = value;

          // 明細選択の変更(再計算無し)
          if (key === 'hasUnderLayerFlg') {
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].hasUnderLayerFlg = secondItems[index].childItems[thirdIndex]
              .childItems[fourthIndex].hasUnderLayerFlg
              ? false
              : true;
            if (
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].hasUnderLayerFlg &&
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].quantity === ''
            ) {
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].quantity = 1;
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].costQuantity = 1;
            }
            calculationFlg = false;
            break;
          }

          // 単位の変更(再計算無し)
          if (key === 'unitId') {
            if (
              secondItems[index].childItems[thirdIndex].childItems[fourthIndex]
                .quantity ==
                secondItems[index].childItems[thirdIndex].childItems[
                  fourthIndex
                ].costQuantity &&
              secondItems[index].childItems[thirdIndex].childItems[fourthIndex]
                .unitId ==
                secondItems[index].childItems[thirdIndex].childItems[
                  fourthIndex
                ].costUnitId
            ) {
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].costUnitId = value;
            }
            calculationFlg = false;
            break;
          }

          // 名称・仕様・備考・原価単位の変更(再計算無し)
          if (
            key === 'name' ||
            key === 'spec' ||
            key === 'remarks' ||
            key === 'author_memo' ||
            key == 'costUnitId'
          ) {
            calculationFlg = false;
            break;
          }

          // 数量・原価数量
          if (key === 'quantity' || key === 'costQuantity') {
            // 「単価・数量が原価単価・原価数量と同じ」場合、原価数量も同時に変更する
            if (
              secondItems[index].childItems[thirdIndex].childItems[fourthIndex]
                .quantity ==
                secondItems[index].childItems[thirdIndex].childItems[
                  fourthIndex
                ].costQuantity &&
              secondItems[index].childItems[thirdIndex].childItems[fourthIndex]
                .unitId ==
                secondItems[index].childItems[thirdIndex].childItems[
                  fourthIndex
                ].costUnitId
            ) {
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].costQuantity = value;
            }
            let totalSellingPrice = 0;
            let totalCostPrice = 0;
            secondItems[index].childItems[thirdIndex].childItems.forEach(
              fourthItem => {
                totalSellingPrice += fourthItem.allSellingPrice
                  ? fourthItem.allSellingPrice
                  : 0;
                totalCostPrice += fourthItem.allCostPrice
                  ? fourthItem.allCostPrice
                  : 0;
              }
            );
            secondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].sellingUnitPrice = totalSellingPrice;
            secondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].costUnitPrice = totalCostPrice;
            secondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].allSellingPrice =
              totalSellingPrice *
              secondItems[index].childItems[thirdIndex].quantity;
            secondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].allCostPrice =
              totalCostPrice *
              secondItems[index].childItems[thirdIndex].costQuantity;
          }

          // ４階層の粗利算出
          copySecondItems[index].childItems[thirdIndex].childItems[
            fourthIndex
          ].allSellingPrice = calcAllSellingPrice(
            Number(
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].quantity
            ),
            Number(
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].sellingUnitPrice
            )
          );
          copySecondItems[index].childItems[thirdIndex].childItems[
            fourthIndex
          ].allCostPrice = calcAllCostPrice(
            Number(
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].costQuantity
            ),
            Number(
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].costUnitPrice
            )
          );
          copySecondItems[index].childItems[thirdIndex].childItems[
            fourthIndex
          ].grossProfit = calcGrossProfit(
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].allSellingPrice,
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].allCostPrice
          );
          // 原価数量が空欄の場合はNaNになるため、0に変換
          copySecondItems[index].childItems[thirdIndex].childItems[
            fourthIndex
          ].grossProfitMargin = calcGrossProfitMargin(
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].allSellingPrice,
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].allCostPrice
          );
          break;

        // 第五階層の入力
        case 5:
          copySecondItems[index].childItems[thirdIndex].childItems[
            fourthIndex
          ].childItems[fifthIndex][key] = value;

          // 明細選択の変更(再計算無し)
          if (key === 'hasUnderLayerFlg') {
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].childItems[fifthIndex].hasUnderLayerFlg = secondItems[index]
              .childItems[thirdIndex].childItems[fourthIndex].childItems[
              fifthIndex
            ].hasUnderLayerFlg
              ? false
              : true;
            calculationFlg = false;
            break;
          }

          // 単位の変更(再計算無し)
          if (key === 'unitId') {
            if (
              secondItems[index].childItems[thirdIndex].childItems[fourthIndex]
                .childItems[fifthIndex].quantity ==
                secondItems[index].childItems[thirdIndex].childItems[
                  fourthIndex
                ].childItems[fifthIndex].costQuantity &&
              secondItems[index].childItems[thirdIndex].childItems[fourthIndex]
                .childItems[fifthIndex].unitId ==
                secondItems[index].childItems[thirdIndex].childItems[
                  fourthIndex
                ].childItems[fifthIndex].costUnitId
            ) {
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].childItems[fifthIndex].costUnitId = value;
            }
            calculationFlg = false;
            break;
          }

          // 名称・仕様・備考・原価単位の変更(再計算無し)
          if (
            key === 'name' ||
            key === 'spec' ||
            key === 'remarks' ||
            key === 'author_memo' ||
            key == 'costUnitId'
          ) {
            calculationFlg = false;
            break;
          }

          // 数量・原価数量
          if (key === 'quantity' || key === 'costQuantity') {
            //「単価・数量が原価単価・原価数量と同じ」場合、原価数量も同時に変更する
            if (
              secondItems[index].childItems[thirdIndex].childItems[fourthIndex]
                .childItems[fifthIndex].quantity ==
                secondItems[index].childItems[thirdIndex].childItems[
                  fourthIndex
                ].childItems[fifthIndex].costQuantity &&
              secondItems[index].childItems[thirdIndex].childItems[fourthIndex]
                .childItems[fifthIndex].unitId ==
                secondItems[index].childItems[thirdIndex].childItems[
                  fourthIndex
                ].childItems[fifthIndex].costUnitId
            ) {
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].childItems[fifthIndex].costQuantity = value;
            }
            // 明細ありの場合は再計算なし
            if (
              secondItems[index].childItems[thirdIndex].childItems[fourthIndex]
                .childItems[fifthIndex].hasUnderLayerFlg
            ) {
              calculationFlg = false;
            }
            let totalSellingPrice = 0;
            let totalCostPrice = 0;
            secondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].childItems.forEach(fifthItem => {
              totalSellingPrice += fifthItem.allSellingPrice
                ? fifthItem.allSellingPrice
                : 0;
              totalCostPrice += fifthItem.allCostPrice
                ? fifthItem.allCostPrice
                : 0;
            });
            secondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].childItems[fifthIndex].sellingUnitPrice = totalSellingPrice;
            secondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].childItems[fifthIndex].costUnitPrice = totalCostPrice;
            secondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].childItems[fifthIndex].allSellingPrice =
              totalSellingPrice *
              secondItems[index].childItems[thirdIndex].childItems[fourthIndex]
                .quantity;
            secondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].childItems[fifthIndex].allCostPrice =
              totalCostPrice *
              secondItems[index].childItems[thirdIndex].childItems[fourthIndex]
                .costQuantity;
          }

          // ５階層の粗利算出
          copySecondItems[index].childItems[thirdIndex].childItems[
            fourthIndex
          ].childItems[fifthIndex].allSellingPrice = calcAllSellingPrice(
            Number(
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].childItems[fifthIndex].quantity
            ),
            Number(
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].childItems[fifthIndex].sellingUnitPrice
            )
          );
          copySecondItems[index].childItems[thirdIndex].childItems[
            fourthIndex
          ].childItems[fifthIndex].allCostPrice = calcAllCostPrice(
            Number(
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].childItems[fifthIndex].costQuantity
            ),
            Number(
              copySecondItems[index].childItems[thirdIndex].childItems[
                fourthIndex
              ].childItems[fifthIndex].costUnitPrice
            )
          );
          copySecondItems[index].childItems[thirdIndex].childItems[
            fourthIndex
          ].childItems[fifthIndex].grossProfit = calcGrossProfit(
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].childItems[fifthIndex].allSellingPrice,
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].childItems[fifthIndex].allCostPrice
          );
          copySecondItems[index].childItems[thirdIndex].childItems[
            fourthIndex
          ].childItems[fifthIndex].grossProfitMargin = calcGrossProfitMargin(
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].childItems[fifthIndex].allSellingPrice,
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].childItems[fifthIndex].allCostPrice
          );
          break;
        default:
          console.log('layer not found.');
          break;
      }
    } else {
      // 項目の削除
      switch (layer) {
        case 2:
          copySecondItems.splice(index, 1);
          break;
        case 3:
          copySecondItems[index].childItems.splice(thirdIndex, 1);
          break;
        case 4:
          copySecondItems[index].childItems[thirdIndex].childItems.splice(
            fourthIndex,
            1
          );
          break;
        case 5:
          copySecondItems[index].childItems[thirdIndex].childItems[
            fourthIndex
          ].childItems.splice(fifthIndex, 1);
          break;
        default:
          console.log('layer not found.');
          break;
      }
    }

    if (calculationFlg) {
      // 第四階層への反映
      if (layer == 5) {
        let totalFifthSellingPrice = 0;
        let totalFifthCostPrice = 0;
        copySecondItems[index].childItems[thirdIndex].childItems[
          fourthIndex
        ].childItems.forEach(fifthItem => {
          totalFifthSellingPrice += fifthItem.allSellingPrice
            ? fifthItem.allSellingPrice
            : 0;
          totalFifthCostPrice += fifthItem.allCostPrice
            ? fifthItem.allCostPrice
            : 0;
        });

        copySecondItems[index].childItems[thirdIndex].childItems[
          fourthIndex
        ].allSellingPrice = calcAllSellingPrice(
          Number(
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].quantity
          ),
          totalFifthSellingPrice
        );
        copySecondItems[index].childItems[thirdIndex].childItems[
          fourthIndex
        ].allCostPrice = calcAllCostPrice(
          Number(
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].costQuantity
          ),
          totalFifthCostPrice
        );
        copySecondItems[index].childItems[thirdIndex].childItems[
          fourthIndex
        ].sellingUnitPrice = totalFifthSellingPrice;
        copySecondItems[index].childItems[thirdIndex].childItems[
          fourthIndex
        ].costUnitPrice = totalFifthCostPrice;

        if (
          copySecondItems[index].childItems[thirdIndex].childItems[fourthIndex]
            .allSellingPrice === 0
        ) {
          copySecondItems[index].childItems[thirdIndex].childItems[
            fourthIndex
          ].grossProfit = 0;
          copySecondItems[index].childItems[thirdIndex].childItems[
            fourthIndex
          ].grossProfitMargin = 0;
        } else {
          copySecondItems[index].childItems[thirdIndex].childItems[
            fourthIndex
          ].grossProfit = calcGrossProfit(
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].allSellingPrice,
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].allCostPrice
          );
          copySecondItems[index].childItems[thirdIndex].childItems[
            fourthIndex
          ].grossProfitMargin = calcGrossProfitMargin(
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].allSellingPrice,
            copySecondItems[index].childItems[thirdIndex].childItems[
              fourthIndex
            ].allCostPrice
          );
        }
      }

      // 第三階層への反映
      if (layer >= 4) {
        let totalFourthSellingPrice = 0;
        let totalFourthCostPrice = 0;
        copySecondItems[index].childItems[thirdIndex].childItems.forEach(
          fourthItem => {
            totalFourthSellingPrice += fourthItem.allSellingPrice
              ? fourthItem.allSellingPrice
              : 0;
            totalFourthCostPrice += fourthItem.allCostPrice
              ? fourthItem.allCostPrice
              : 0;
          }
        );

        copySecondItems[index].childItems[thirdIndex].allSellingPrice =
          calcAllSellingPrice(
            Number(copySecondItems[index].childItems[thirdIndex].quantity),
            totalFourthSellingPrice
          );
        copySecondItems[index].childItems[thirdIndex].allCostPrice =
          calcAllCostPrice(
            Number(copySecondItems[index].childItems[thirdIndex].costQuantity),
            totalFourthCostPrice
          );
        copySecondItems[index].childItems[thirdIndex].sellingUnitPrice =
          totalFourthSellingPrice;
        copySecondItems[index].childItems[thirdIndex].costUnitPrice =
          totalFourthCostPrice;

        if (
          copySecondItems[index].childItems[thirdIndex].allSellingPrice == 0
        ) {
          copySecondItems[index].childItems[thirdIndex].grossProfit = 0;
          copySecondItems[index].childItems[thirdIndex].grossProfitMargin = 0;
        } else {
          copySecondItems[index].childItems[thirdIndex].grossProfit =
            calcGrossProfit(
              copySecondItems[index].childItems[thirdIndex].allSellingPrice,
              copySecondItems[index].childItems[thirdIndex].allCostPrice
            );
          copySecondItems[index].childItems[thirdIndex].grossProfitMargin =
            calcGrossProfitMargin(
              copySecondItems[index].childItems[thirdIndex].allSellingPrice,
              copySecondItems[index].childItems[thirdIndex].allCostPrice
            );
        }
      }

      // 第二階層への反映
      if (layer >= 3) {
        let totalThirdSellingPrice = 0;
        let totalThirdCostPrice = 0;
        copySecondItems[index].childItems.forEach(thirdItem => {
          totalThirdSellingPrice += thirdItem.allSellingPrice
            ? thirdItem.allSellingPrice
            : 0;
          totalThirdCostPrice += thirdItem.allCostPrice
            ? thirdItem.allCostPrice
            : 0;
        });

        copySecondItems[index].allSellingPrice = calcAllSellingPrice(
          Number(copySecondItems[index].quantity),
          totalThirdSellingPrice
        );
        copySecondItems[index].allCostPrice = calcAllCostPrice(
          Number(copySecondItems[index].costQuantity),
          totalThirdCostPrice
        );
        copySecondItems[index].sellingUnitPrice = totalThirdSellingPrice;
        copySecondItems[index].costUnitPrice = totalThirdCostPrice;

        if (copySecondItems[index].allSellingPrice == 0) {
          copySecondItems[index].grossProfit = 0;
          copySecondItems[index].grossProfitMargin = 0;
        } else {
          copySecondItems[index].grossProfit = calcGrossProfit(
            copySecondItems[index].allSellingPrice,
            copySecondItems[index].allCostPrice
          );
          copySecondItems[index].grossProfitMargin = calcGrossProfitMargin(
            copySecondItems[index].allSellingPrice,
            copySecondItems[index].allCostPrice
          );
        }
      }
    }

    setSecondItems(copySecondItems);
  };

  /**
   * 大項目計算
   */
  const calcTotalBreakDown = useCallback(() => {
    let copyMainItem = _.cloneDeep(mainItem);
    let totalSellingPrice = 0;
    let totalCostPrice = 0;

    // 第一階層が明細ありの場合
    if (mainItem.hasUnderLayerFlg) {
      secondItems.forEach(secondItem => {
        totalSellingPrice += secondItem.allSellingPrice
          ? secondItem.allSellingPrice
          : 0;
        totalCostPrice += secondItem.allCostPrice ? secondItem.allCostPrice : 0;
      });
      copyMainItem.allSellingPrice = calcAllSellingPrice(
        Number(copyMainItem.quantity),
        totalSellingPrice
      );
      copyMainItem.allCostPrice = calcAllCostPrice(
        Number(copyMainItem.costQuantity),
        totalCostPrice
      );
      copyMainItem.sellingUnitPrice = totalSellingPrice;
      copyMainItem.costUnitPrice = totalCostPrice;
    } else {
      // 第一階層が明細無しの場合
      copyMainItem.allSellingPrice = calcAllSellingPrice(
        Number(copyMainItem.quantity),
        Number(copyMainItem.sellingUnitPrice)
      );
      copyMainItem.allCostPrice = calcAllCostPrice(
        Number(copyMainItem.costQuantity),
        Number(copyMainItem.sellingUnitPrice)
      );
    }

    copyMainItem.grossProfit = calcGrossProfit(
      copyMainItem.allSellingPrice,
      copyMainItem.allCostPrice
    );
    copyMainItem.grossProfitMargin =
      copyMainItem.allSellingPrice !== 0
        ? calcGrossProfitMargin(
            copyMainItem.allSellingPrice,
            copyMainItem.allCostPrice
          )
        : 0;

    setMainItem(copyMainItem);
  }, [secondItems]);

  useEffect(() => {
    calcTotalBreakDown();
  }, [secondItems, calcTotalBreakDown]);

  useEffect(() => {
    getListOfMUnits();
    if (params.id) {
      getTheListOfEstimateMasterDetails();
    } else {
      initializeSecondItems();
    }
  }, [
    getListOfMUnits,
    getTheListOfEstimateMasterDetails,
    initializeSecondItems,
    params.id
  ]);

  /**
   * マスタ新規作成（編集画面の場合は更新）
   */
  const updateOrCreateEstimateMasterDetails = () => {
    setProgressFlg(true);
    const newSecondItems: TNewSecondItem[] = [];
    secondItems.forEach((secondItem: TSecondItem) => {
      const newThridItem: TNewThirdItem[] = [];
      if (secondItem.hasUnderLayerFlg && secondItem.childItems.length > 0) {
        secondItem.childItems.forEach((thirdItem: TSecondItem) => {
          const newFourthItem: TNewFourthItem[] = [];
          if (thirdItem.hasUnderLayerFlg && thirdItem.childItems.length > 0) {
            thirdItem.childItems.forEach((fourthItem: TSecondItem) => {
              const newFifthItem: TNewFifthItem[] = [];
              if (
                fourthItem.hasUnderLayerFlg &&
                fourthItem.childItems.length > 0
              ) {
                fourthItem.childItems.forEach((fifthItem: any) => {
                  newFifthItem.push({
                    name: fifthItem.name,
                    spec: fifthItem.spec,
                    order_id: -1,
                    quantity: fifthItem.quantity
                      ? fifthItem.quantity
                      : fifthItem.quantity === 0
                      ? 0
                      : null,
                    cost_quantity: fifthItem.costQuantity
                      ? fifthItem.costQuantity
                      : fifthItem.costQuantity === 0
                      ? 0
                      : null,
                    unit_id: fifthItem.unitId,
                    cost_unit_id: fifthItem.costUnitId,
                    selling_unit_price: Number(fifthItem.sellingUnitPrice),
                    cost_unit_price: Number(fifthItem.costUnitPrice),
                    remarks: fifthItem.remarks,
                    author_memo: fifthItem.author_memo,
                    layer: 5,
                    has_under_layer_flg: fifthItem.hasUnderLayerFlg
                  });
                });
              }
              newFourthItem.push({
                name: fourthItem.name,
                spec: fourthItem.spec,
                order_id: -1,
                quantity: fourthItem.quantity
                  ? fourthItem.quantity
                  : fourthItem.quantity === 0
                  ? 0
                  : null,
                cost_quantity: fourthItem.costQuantity
                  ? fourthItem.costQuantity
                  : fourthItem.costQuantity === 0
                  ? 0
                  : null,
                unit_id: fourthItem.unitId,
                cost_unit_id: fourthItem.costUnitId,
                selling_unit_price: Number(fourthItem.sellingUnitPrice),
                cost_unit_price: Number(fourthItem.costUnitPrice),
                remarks: fourthItem.remarks,
                author_memo: fourthItem.author_memo,
                layer: 4,
                has_under_layer_flg: fourthItem.hasUnderLayerFlg,
                fifth_items: newFifthItem
              });
            });
          }
          newThridItem.push({
            name: thirdItem.name,
            spec: thirdItem.spec,
            order_id: -1,
            quantity: thirdItem.quantity
              ? thirdItem.quantity
              : thirdItem.quantity === 0
              ? 0
              : null,
            cost_quantity: thirdItem.costQuantity
              ? thirdItem.costQuantity
              : thirdItem.costQuantity === 0
              ? 0
              : null,
            unit_id: thirdItem.unitId,
            cost_unit_id: Number(thirdItem.costUnitId),
            selling_unit_price: Number(thirdItem.sellingUnitPrice),
            cost_unit_price: thirdItem.costUnitPrice,
            remarks: thirdItem.remarks,
            author_memo: thirdItem.author_memo,
            layer: 3,
            has_under_layer_flg: thirdItem.hasUnderLayerFlg,
            fourth_items: newFourthItem
          });
        });
      }
      newSecondItems.push({
        name: secondItem.name,
        spec: secondItem.spec,
        order_id: -1,
        quantity: secondItem.quantity
          ? secondItem.quantity
          : secondItem.quantity === 0
          ? 0
          : null,
        cost_quantity: secondItem.costQuantity
          ? secondItem.costQuantity
          : secondItem.costQuantity === 0
          ? 0
          : null,
        unit_id: secondItem.unitId,
        cost_unit_id: secondItem.costUnitId,
        selling_unit_price: Number(secondItem.sellingUnitPrice),
        cost_unit_price: Number(secondItem.costUnitPrice),
        remarks: secondItem.remarks,
        author_memo: secondItem.author_memo,
        layer: 2,
        has_under_layer_flg: secondItem.hasUnderLayerFlg,
        third_items: newThridItem
      });
    });

    if (params.id) {
      // 編集画面
      updateEstimateMaster(
        params.id,
        mainItem.name.trim(),
        mainItem.spec.trim(),
        mainItem.order_id,
        mainItem.quantity
          ? mainItem.quantity
          : mainItem.quantity === 0
          ? 0
          : null,
        mainItem.costQuantity
          ? mainItem.costQuantity
          : mainItem.costQuantity === 0
          ? 0
          : null,
        mainItem.unitId,
        mainItem.costUnitId,
        Number(mainItem.sellingUnitPrice),
        Number(mainItem.costUnitPrice),
        mainItem.remarks,
        mainItem.author_memo,
        1,
        mainItem.hasUnderLayerFlg,
        newSecondItems
      ).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
            setProgressFlg(false);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
              setProgressFlg(false);
            } else {
              setErrorMessage(data.message);
              setOpenSuccess(true);
              getTheListOfEstimateMasterDetails();
              setProgressFlg(false);
            }
          }
        }
      });
    } else {
      // 新規作成画面
      createEstimateMaster(
        mainItem.name.trim(),
        mainItem.spec.trim(),
        -1,
        mainItem.quantity
          ? mainItem.quantity
          : mainItem.quantity === 0
          ? 0
          : null,
        mainItem.costQuantity
          ? mainItem.costQuantity
          : mainItem.costQuantity === 0
          ? 0
          : null,
        mainItem.unitId,
        mainItem.costUnitId,
        mainItem.sellingUnitPrice,
        mainItem.costUnitPrice,
        mainItem.remarks,
        mainItem.author_memo,
        1,
        mainItem.hasUnderLayerFlg,
        newSecondItems
      ).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
            setProgressFlg(false);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
              setProgressFlg(false);
            } else {
              setErrorMessage(data.message);
              setOpenSuccess(true);
              setTimeout(() => {
                history.goBack();
              }, 2000);
              setProgressFlg(false);
            }
          }
        }
      });
    }
  };

  /**
   * 保存ボタン押下
   */
  const saveBtnPressed = () => {
    if (mainItem.name.trim() === '') {
      setErrorMessage('大項目を入力してください。');
      setOpen(true);
      return;
    } else {
      updateOrCreateEstimateMasterDetails();
    }
  };

  /**
   * 削除ボタン押下
   */
  const deleteEstimateMasterItem = () => {
    deleteEstimateMasterList([params.id]).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
            setTimeout(() => {
              history.goBack();
            }, 2000);
          }
        }
      }
    });
  };

  // パンくずリスト表示パターン(編集)
  let patternName = 'estimate_master_edit';

  // 新規作成画面のモードの場合
  if (location.pathname.match('create')) {
    // パンくずリスト表示パターン(新規)
    patternName = 'estimate_master_create';
  }

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <div>
      <AppBarComponent patternName={patternName} />
      {loading && history.location.state ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            overflow: 'hidden',
            backgroundColor: '#F5F5F5',
            minHeight: window.innerHeight - 120
          }}
        >
          <div style={{ margin: 15 }}>
            <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
              <Alert onClose={handleClose} severity='error'>
                {errorMessage}
              </Alert>
            </Snackbar>

            <Snackbar
              open={openSuccess}
              autoHideDuration={4000}
              onClose={handleCloseSuccess}
            >
              <Alert onClose={handleCloseSuccess} severity='success'>
                {errorMessage}
              </Alert>
            </Snackbar>

            {/* マスタ削除のアラート */}
            <DocumentDeleteModal
              documentType={'見積書マスタ'}
              documentDeleteModal={documentDeleteModal}
              setDocumentDeleteModal={setDocumentDeleteModal}
              deleteDocument={deleteEstimateMasterItem}
            />

            <div className='table-top-container-customer'>
              <div>
                <Button
                  style={{
                    marginRight: 15,
                    backgroundColor: buttonColor
                  }}
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    saveBtnPressed();
                  }}
                >
                  保存
                </Button>
                {params.id && (
                  <Button
                    style={{
                      color: '#758283',
                      backgroundColor: '#F5F5F5'
                    }}
                    variant='contained'
                    color='primary'
                    onClick={() => {
                      setDocumentDeleteModal(true);
                    }}
                  >
                    削除
                  </Button>
                )}
              </div>
            </div>
            <div style={{ backgroundColor: '#FFFFFF', marginBottom: 15 }}>
              <div
                style={{
                  fontWeight: 'bold',
                  padding: 15,
                  paddingBottom: 0,
                  fontSize: 24
                }}
              >
                {params.id ? '見積マスタ編集' : '見積書マスタ作成'}
              </div>

              <div style={{ overflow: 'scroll' }}>
                <Grid container style={{ marginBottom: 20, paddingRight: 15 }}>
                  <Grid item xs={matches2 ? 4 : 12}>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>明細</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          {(mainItem.hasUnderLayerFlg == true ||
                            (mainItem.sellingUnitPrice == 0 &&
                              mainItem.costUnitPrice == 0)) && (
                            <select
                              value={
                                mainItem.hasUnderLayerFlg ? 'true' : 'false'
                              }
                              disabled={
                                mainItem.hasUnderLayerFlg == true &&
                                secondItems.length > 0
                              }
                              onChange={text => {
                                updateMainItemList(
                                  'hasUnderLayerFlg',
                                  text.target.value === 'true' ? true : false
                                );
                              }}
                              className={classes.selectLayerType}
                              name='cars'
                              form='carform'
                            >
                              <option value='true'>明細あり</option>
                              <option value='false'>明細なし</option>
                            </select>
                          )}
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          大項目<span>*</span>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={mainItem.name}
                            maxLength={20}
                            placeholder={'20文字以内で入力'}
                            onChange={text => {
                              updateMainItemList('name', text.target.value);
                            }}
                            className={classes.input}
                            style={{
                              width: '36ch',
                              fontSize: 15.5
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>仕様</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <textarea
                            value={mainItem.spec}
                            maxLength={42}
                            style={{
                              height: 50,
                              maxHeight: 60,
                              fontSize: 15.5,
                              width: '36ch'
                            }}
                            placeholder={'40文字以内、2行以内'}
                            onChange={text => {
                              handleTextValidation(
                                text.target.value,
                                40,
                                2,
                                null,
                                (cleanText: string) => {
                                  validateTextareaInput(
                                    'spec',
                                    cleanText,
                                    (cleanText: string) => {
                                      updateMainItemList('spec', cleanText);
                                    }
                                  );
                                }
                              );
                            }}
                            className={classes.input2}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>備考</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <textarea
                            value={mainItem.remarks}
                            maxLength={42}
                            style={{
                              height: 50,
                              maxHeight: 60,
                              fontSize: 15.5,
                              width: '36ch'
                            }}
                            placeholder={'40文字以内、2行以内'}
                            onChange={text => {
                              handleTextValidation(
                                text.target.value,
                                40,
                                2,
                                null,
                                (cleanText: string) => {
                                  validateTextareaInput(
                                    'remarks',
                                    cleanText,
                                    (cleanText: string) => {
                                      updateMainItemList('remarks', cleanText);
                                    }
                                  );
                                }
                              );
                            }}
                            className={classes.input2}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          （社内用メモ）
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <textarea
                            value={mainItem.author_memo}
                            maxLength={42}
                            style={{
                              height: 50,
                              maxHeight: 60,
                              fontSize: 15.5,
                              width: '36ch'
                            }}
                            placeholder={'40文字以内、2行以内'}
                            onChange={text => {
                              handleTextValidation(
                                text.target.value,
                                40,
                                2,
                                null,
                                (cleanText: string) => {
                                  validateTextareaInput(
                                    'author_memo',
                                    cleanText,
                                    (cleanText: string) => {
                                      updateMainItemList(
                                        'author_memo',
                                        cleanText
                                      );
                                    }
                                  );
                                }
                              );
                            }}
                            className={classes.smallMemoInput}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>

                  <Grid item xs={matches2 ? 4 : 12}>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainerMainItem}>
                          数量
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputQuantityContainer}>
                          <input
                            style={{
                              height: 40,
                              width: '40%',
                              textAlign: 'right'
                            }}
                            value={mainItem.quantity}
                            type='number'
                            min='0'
                            onChange={text => {
                              updateMainItemList(
                                'quantity',
                                parseFloat(text.target.value)
                              );
                            }}
                            onWheel={(e: any) => e.target.blur()}
                          />
                          <select
                            style={{ height: 40, width: '40%' }}
                            value={String(mainItem.unitId)}
                            onChange={text => {
                              updateMainItemList('unitId', text.target.value);
                            }}
                            name='cars'
                            form='carform'
                          >
                            <option value='0'>---</option>
                            {mUnitsData.map((i: any) => (
                              <option value={i.id}>{i.name}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          （原価数量）
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        （
                        <div className={classes.inputQuantityContainer}>
                          <input
                            style={{
                              height: 40,
                              width: '40%',
                              color: 'blue',
                              textAlign: 'right'
                            }}
                            value={mainItem.costQuantity}
                            type='number'
                            min='0'
                            onChange={text => {
                              updateMainItemList(
                                'costQuantity',
                                parseFloat(text.target.value)
                              );
                            }}
                            onWheel={(e: any) => e.target.blur()}
                          />
                          <select
                            style={{ height: 40, width: '40%', color: 'blue' }}
                            value={String(mainItem.costUnitId)}
                            onChange={text => {
                              updateMainItemList(
                                'costUnitId',
                                text.target.value
                              );
                            }}
                            name='cars'
                            form='carform'
                          >
                            <option disabled selected value='0'>
                              ---
                            </option>
                            {mUnitsData.map((i: any) => (
                              <option value={i.id}>{i.name}</option>
                            ))}
                          </select>
                        </div>
                        ）
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainerMainItem}>
                          単価
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputMainItemQuantity}>
                          <NumberInput
                            style={{ height: 40, width: '80%' }}
                            value={
                              mainItem.sellingUnitPrice === 0
                                ? '0'
                                : mainItem.sellingUnitPrice
                            }
                            disabled={mainItem.hasUnderLayerFlg == true}
                            symbol=''
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              updateMainItemList(
                                'sellingUnitPrice',
                                e.target.value ? Number(e.target.value) : 0
                              );
                            }}
                            dynamicCalculation={true}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          （原価単価）
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        （
                        <div className={classes.inputMainItemQuantity}>
                          <NumberInput
                            style={{ height: 40, width: '80%', color: 'blue' }}
                            value={
                              mainItem.costUnitPrice === 0
                                ? '0'
                                : mainItem.costUnitPrice
                            }
                            disabled={mainItem.hasUnderLayerFlg == true}
                            symbol=''
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              updateMainItemList(
                                'costUnitPrice',
                                e.target.value ? Number(e.target.value) : 0
                              );
                            }}
                            className={classes.smallInput}
                            dynamicCalculation={true}
                          />
                        </div>
                        ）
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>

                  <Grid item xs={matches2 ? 4 : 12}>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainerMainItem}>
                          定価合計
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>
                          <span style={{ paddingRight: 14 }}>
                            {parsePrice(
                              mainItem.allSellingPrice >= 0
                                ? mainItem.allSellingPrice
                                : '',
                              ''
                            )}
                          </span>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          （原価合計）
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>
                          （
                          <span style={{ color: 'blue' }}>
                            {parsePrice(
                              mainItem.allCostPrice >= 0
                                ? mainItem.allCostPrice
                                : '',
                              ''
                            )}
                          </span>
                          ）
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainerMainItem}>
                          粗利
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>
                          <span style={{ paddingRight: 14 }}>
                            {parsePrice(mainItem.grossProfit, '')}
                          </span>
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainerMainItem}>
                          粗利率
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.textContainerPrice}>
                          {mainItem.grossProfitMargin}%
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>
                </Grid>

                <div style={{ margin: 15 }}>
                  <TableContainer
                    component={Paper}
                    style={{ marginBottom: 15 }}
                  >
                    <Table
                      className={classes.main}
                      aria-label='customized table'
                      style={{ minWidth: 1840 }}
                    >
                      {/* ヘッダー */}
                      <ItemTableHead />

                      <TableBody>
                        {/* 第二階層 */}
                        {secondItems.map((secondItem: any, index: number) => (
                          <>
                            {(index == 0 ||
                              (secondItems[index - 1] &&
                                secondItems[index - 1].hasUnderLayerFlg ==
                                  true)) && (
                              <Breadcrumbs
                                layer={2}
                                itemName={[mainItem.name]}
                                itemLength={secondItems.length}
                                addNewItem={addNewItem}
                              />
                            )}
                            <ItemList
                              mUnitsData={mUnitsData}
                              layer={2}
                              item={secondItem}
                              updateSecondItemList={updateSecondItemList}
                              index={index}
                            />
                            {/* 第三階層 */}
                            {secondItem.childItems.length > 0 &&
                              secondItem.childItems.map(
                                (thirdItem: any, thirdIndex: number) => (
                                  <>
                                    {(thirdIndex === 0 ||
                                      secondItem.childItems[thirdIndex - 1]
                                        .hasUnderLayerFlg == true) && (
                                      <Breadcrumbs
                                        layer={thirdItem.layer}
                                        itemName={[
                                          mainItem.name,
                                          secondItem.name
                                        ]}
                                        itemLength={
                                          secondItem.childItems.length
                                        }
                                        addNewItem={addNewItem}
                                        index={index}
                                        thirdIndex={thirdIndex}
                                      />
                                    )}
                                    <ItemList
                                      mUnitsData={mUnitsData}
                                      layer={3}
                                      item={thirdItem}
                                      updateSecondItemList={
                                        updateSecondItemList
                                      }
                                      index={index}
                                      thirdIndex={thirdIndex}
                                    />
                                    {/* 第四階層 */}
                                    {thirdItem.childItems.length > 0 &&
                                      thirdItem.childItems.map(
                                        (
                                          fourthItem: any,
                                          fourthIndex: number
                                        ) => (
                                          <>
                                            {(fourthIndex === 0 ||
                                              thirdItem.childItems[
                                                fourthIndex - 1
                                              ].hasUnderLayerFlg == true) && (
                                              <Breadcrumbs
                                                layer={fourthItem.layer}
                                                itemName={[
                                                  mainItem.name,
                                                  secondItem.name,
                                                  thirdItem.name
                                                ]}
                                                itemLength={
                                                  thirdItem.childItems.length
                                                }
                                                addNewItem={addNewItem}
                                                index={index}
                                                thirdIndex={thirdIndex}
                                              />
                                            )}
                                            <ItemList
                                              mUnitsData={mUnitsData}
                                              layer={4}
                                              item={fourthItem}
                                              updateSecondItemList={
                                                updateSecondItemList
                                              }
                                              index={index}
                                              thirdIndex={thirdIndex}
                                              fourthIndex={fourthIndex}
                                            />

                                            {/* 第五階層 */}
                                            {fourthItem.childItems.length > 0 &&
                                              fourthItem.childItems.map(
                                                (
                                                  fifthItem: any,
                                                  fifthIndex: number
                                                ) => (
                                                  <>
                                                    {(fifthIndex === 0 ||
                                                      fourthItem.childItems[
                                                        fifthIndex - 1
                                                      ].hasUnderLayerFlg ==
                                                        true) && (
                                                      <Breadcrumbs
                                                        layer={fifthItem.layer}
                                                        itemName={[
                                                          mainItem.name,
                                                          secondItem.name,
                                                          thirdItem.name,
                                                          fourthItem.name
                                                        ]}
                                                        itemLength={
                                                          fourthItem.childItems
                                                            .length
                                                        }
                                                        addNewItem={addNewItem}
                                                        index={index}
                                                        thirdIndex={thirdIndex}
                                                        fourthIndex={
                                                          fourthIndex
                                                        }
                                                      />
                                                    )}
                                                    <ItemList
                                                      mUnitsData={mUnitsData}
                                                      layer={5}
                                                      item={fifthItem}
                                                      updateSecondItemList={
                                                        updateSecondItemList
                                                      }
                                                      index={index}
                                                      thirdIndex={thirdIndex}
                                                      fourthIndex={fourthIndex}
                                                      fifthIndex={fifthIndex}
                                                    />
                                                  </>
                                                )
                                              )}
                                            {/* 第五階層追加ボタン */}
                                            {fourthItem.hasUnderLayerFlg &&
                                              fourthItem.childItems.length ===
                                                0 && (
                                                <AddUnderLayerItemButtom
                                                  layer={5}
                                                  index={index}
                                                  thirdIndex={thirdIndex}
                                                  fourthIndex={fourthIndex}
                                                  addNewItem={addNewItem}
                                                />
                                              )}
                                          </>
                                        )
                                      )}
                                    {/* 第四階層追加ボタン */}
                                    {thirdItem.hasUnderLayerFlg &&
                                      thirdItem.childItems.length === 0 && (
                                        <AddUnderLayerItemButtom
                                          layer={4}
                                          index={index}
                                          thirdIndex={thirdIndex}
                                          addNewItem={addNewItem}
                                        />
                                      )}
                                  </>
                                )
                              )}
                            {/* 第三階層追加ボタン */}
                            {secondItem.hasUnderLayerFlg &&
                              secondItem.childItems.length === 0 && (
                                <AddUnderLayerItemButtom
                                  layer={3}
                                  index={index}
                                  addNewItem={addNewItem}
                                />
                              )}
                          </>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      padding: '10px, 0px'
                    }}
                  >
                    {mainItem.hasUnderLayerFlg && secondItems.length === 0 && (
                      <Button
                        style={{ backgroundColor: buttonColor }}
                        variant='contained'
                        color='primary'
                        onClick={() => {
                          addNewItem(2);
                        }}
                      >
                        <LibraryAddIcon />
                        <span style={{ marginLeft: 8 }}>項目を追加</span>
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ height: 60 }} />
        </div>
      )}
      <FooterComponent />
    </div>
  );
};
